// Utility function to determine if an element is focusable
export const isFocusable = (element: HTMLElement | null): boolean => {
    if (!element) return false;
    const focusableTags = ['A', 'BUTTON', 'INPUT', 'TEXTAREA', 'SELECT'];
    return (
        (focusableTags.includes(element.tagName) && !(element as HTMLInputElement).disabled) ||
        (element.tabIndex >= 0 && element.getAttribute('tabindex') !== '-1')
    );
};

// Function to get the previous or next focusable element
export const getFocusableElement = (
    currentElement: HTMLElement | null,
    direction: 'next' | 'previous' = 'next'
): HTMLElement | null => {
    if (!currentElement) return null;
    const allElements = Array.from(document.querySelectorAll<HTMLElement>('*') ?? []);
    const currentIndex = allElements.indexOf(currentElement);

    if (direction === 'next') {
        for (let i = currentIndex + 1; i < allElements.length; i++) {
            const e = allElements[i] ?? null;
            if (isFocusable(e) && !currentElement.contains(e)) {
                return e;
            }
        }
    } else if (direction === 'previous') {
        for (let i = currentIndex - 1; i >= 0; i--) {
            const e = allElements[i] ?? null;
            if (isFocusable(e) && !currentElement.contains(e)) {
                return e;
            }
        }
    }

    return null; // Return null if no focusable element is found
};


export const findNextFocusable = (currentElement: HTMLElement | null) => {
    const nextFocusable = getFocusableElement(currentElement, 'next');
    if (nextFocusable) {
        nextFocusable.focus();
    }
};

export const findPreviousFocusable = (currentElement: HTMLElement | null) => {
    const previousFocusable = getFocusableElement(currentElement, 'previous');
    if (previousFocusable) {
        previousFocusable.focus();
    }
};

export const unlockBodyScroll = () => {
    const $html = document.querySelector('html');
    const $body = document.querySelector('body');
    const scrollPosition = 0;
    if ($html) {
        $html.style.removeProperty('overflow');
    }
    if ($body) {
        $body.style.removeProperty('overflow');
        $body.style.removeProperty('position');
        $body.style.removeProperty('top');
        $body.style.removeProperty('width');
        window.scrollTo(0, scrollPosition);
    }
};